import { projectSharedCss } from '@app/projects/list/style.css';
import { UserService } from '@core/services/user/user.service';
import { Inject } from '@rxdi/core';
import { Component, css, html, LitElement, property, styleMap } from '@rxdi/lit-html';
import * as firebase from 'firebase/app';
import ImageResize from 'image-resize';
import { firstValueFrom } from 'rxjs';
import { error } from 'toastr';

import { MaterialBoxCSS } from '../styles/material-box';

function dataURLtoBlob(dataurl) {
  const arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

function blobToDataURL(blob, callback) {
  const a = new FileReader();
  a.onload = function (e) {
    callback(e.target.result);
  };
  a.readAsDataURL(blob);
}

/**
 * @customElement info-header-card-component
 */
@Component({
  selector: 'info-header-card-component',
  style: css`
    ${projectSharedCss}
    ${MaterialBoxCSS}

    p {
      margin-top: 0px;
      margin-bottom: 5px;
    }
    p.size-13 {
      font-size: 13px;
    }

    .profile-information {
      font-size: 13px;
      color: #0e0e0e;
      font-weight: bold;
    }

    .profile-information-container {
      width: 100px;
      color: #0e0e0e;
      font-size: 14px;
    }
    .info-header-container {
      padding: 20px;
      margin-top: 0px;
    }

    .info-header-container .title {
      font-size: 22px;
      font-weight: bold;
      color: #324044;
    }

    .image {
      cursor: pointer;
    }
    .image:hover {
      opacity: 0.7;
    }
  `,
  template(this: InfoHeaderCardComponent) {
    return html`
      <card-component>
        <div class="flex">
          <label class="image">
            <file-uploader
              .acceptsMultipleFiles=${false}
              @filesDropped=${async (e: CustomEvent<File[]>) => {
                if (e.detail.length > 1) {
                  error('Please select only one image');
                }

                const imageResize = new ImageResize({
                  format: 'png',
                  width: 100,
                  height: 100,
                });
                const file = await imageResize.play(e.detail[0]);

                const user = firebase.auth().currentUser;
                const storageRef = firebase.storage().ref(`/profile/${user.uid}.${e.detail[0].name.split('.')[1]}`);
                storageRef.put(dataURLtoBlob(file));
                const photoURL = await storageRef.getDownloadURL();
                await user.updateProfile({ photoURL });
                await firstValueFrom(this.userService.updateProfile({ photoURL }));
                this.photoURL = photoURL;
              }}
            >
              ${this.photoURL
                ? html`
                    <div>
                      <img
                        style=${styleMap({
                          'border-radius': this.photoRadius,
                          width: this.photoWidth,
                          height: this.photoWidth,
                          padding: '15px',
                        })}
                        src=${this.photoURL}
                      />
                    </div>
                  `
                : html` <slot></slot> `}
            </file-uploader>
          </label>
          <div class="info-header-container" style=${this.styleContainer}>
            <p class="title">${this.headerTitle}</p>
            ${this.infoItems.length
              ? html` ${this.infoItems.map((i) => html` <p class="size-13">${i}</p> `)} `
              : html` <slot name="items"></slot> `}
          </div>
        </div>
      </card-component>
    `;
  },
})
export class InfoHeaderCardComponent extends LitElement {
  @property() headerTitle: string;
  @property({ type: Array }) infoItems: string[] = [];
  @property() photoURL: string;
  @property() photoWidth = '100px';
  @property() photoRadius = '85px';
  @property() styleContainer = '';

  @Inject(UserService)
  userService: UserService;

  OnInit() {
    // const user = firebase.auth().currentUser;
    // const storageRef = firebase.storage().ref(user.email + '/profile/' + 'file.name');
    // debugger;
    // storageRef.put(new Blob());
  }
}
